export const isTestingPlaywright = process.env.NODE_ENV === 'test';
let isTestingEmber = false;

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  isTestingEmber = Boolean(document.getElementById('qunit'));
}

export const isTesting = isTestingPlaywright || isTestingEmber;
